import React from 'react';
import { connect } from 'react-redux';
import { Loader, Text, Theme, Button, Logo } from '@simplybenefits/sb-ui-library';
import { logout } from '../../actions/master.js';

/**
 * 
 */
const Forbidden = ({ loader, dispatch }) => {

    /**
     * @param {*} link 
     */
    const _navigateTo = (link) => {
        window.location.href = link;
    };

    /**
     */
    const _logout = () => {
        dispatch(logout());
    };

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        },
        buttonWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 25,
            width: 350
        }
    };

    return (
        <div style={styles.container}>
            <Logo whitelabel />

            <Text largest bold>403: Forbidden</Text>
            <Text medium>You do not have access to view this page. If you think this is wrong, please contact your manager.</Text>

            <div style={ styles.buttonWrapper }>
                <Button
                    onClick={() => _navigateTo('/')}
                    color="primary"
                    fullWidth
                >
                    Navigate to Home
                </Button>

                <Text small margin="10px 0 0px">or</Text>

                <Button
                    onClick={_logout}
                    transparent
                >
                    <Text medium bold color={Theme.colors.red}>Logout</Text>
                </Button>
            </div>

            { loader?.isLoading && <Loader isContainer/> }
        </div>
    );
    
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default (connect(mapStateToProps)(Forbidden));